// extracted by mini-css-extract-plugin
export default {"button":"kKJefNyniICJoUY","active":"Nj2O6yZy9VGIJCr","passed":"KOOGFkhWdhSEOIV"};